export default __webpack_public_path__ + "static/media/clarity-si2.833142ed.webp";